import React from "react";
import blogsData from "../../data/blogsData";
import "./Blog.scss";
import { Link } from "react-router-dom";

export default function Blog() {
  // Sort blogs by date (latest first)
  const sortedBlogs = [...blogsData].sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );

  return (
    <section id="blogs" className="blog-section">
      <div className="container">

        {/* Heading + Subheading */}
        <div className="text-content">
          <h2 className="section-heading">BLOGS</h2>
          <p className="section-subheading">
            Latest Dental Tips, Treatments & Expert Insights
          </p>
        </div>

        {/* Blog Cards */}
        <div className="blog-grid">
          {sortedBlogs.slice(0, 3).map((blog) => (
            <Link
              to={`/blog/${blog.slug}`}
              className="blog-card"
              key={blog.id}
            >
              <div className="blog-img">
                <img src={blog.image} alt={blog.title} />
              </div>

              <div className="blog-content">
                <h3>{blog.title}</h3>

                {/* Date + Read time */}
                <div className="blog-meta">
                  <span className="date">
                    {new Date(blog.date).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </span>

                  <span className="readtime">{blog.readTime}</span>
                </div>

                <p>{blog.shortDescription}</p>

                <span className="read-more">Read More →</span>
              </div>
            </Link>
          ))}
        </div>

        {/* View More Button */}
        <div className="center-btn">
          <Link to="/blogs" className="view-more-btn">
            View More Blogs
          </Link>
        </div>

      </div>
    </section>
  );
}
